import { Drawer, makeStyles } from '@material-ui/core';
import VinModificationLayout from './VinModificationLayout';

const useStyles = makeStyles(() => ({
  contentDrawer: {
    height: '100vh',
  },
}));

type Props = {
  open: boolean;
  quotationHash: string;
  onClose: () => void;
};

const VinModificationDrawer = ({
  open,
  quotationHash,
  onClose,
}: Props): JSX.Element => {
  const classes = useStyles();
  return (
    <Drawer
      data-testid="vin-drawer"
      anchor="right"
      open={open}
      onClick={onClose}
    >
      <div
        onClick={(e): void => e.stopPropagation()}
        onKeyDown={(e): void => e.stopPropagation()}
        data-testid="drawer-content"
        role="none"
        className={classes.contentDrawer}
      >
        <VinModificationLayout
          quotationHash={quotationHash}
          onClose={onClose}
          data-testid="vin-layout"
        />
      </div>
    </Drawer>
  );
};

export default VinModificationDrawer;
